import {Col, Row, Spin, Alert} from 'antd'
import {useEffect, useState} from 'react'
import {CARDS_GUTTER} from 'helpers/dashboards'
import {GET} from 'helpers/api'
import {useSelector} from 'react-redux'
import {calculateEndDate} from 'helpers/dates'
import ThermalImage, {ThermalLegend} from '@components/thermal-image'
import {useDomain} from 'contexts/DomainContext'

export const ThermalRow = ({targetsview, temperature, interval}) => {
  const token = useSelector(state => state.auth.token)
  const [thermals, setThermals] = useState(null)
  const [loading, setLoading] = useState(false)
  const {domain} = useDomain()

  useEffect(() => {
    const loadData = async (tgid, start, end) => {
      setLoading(true)
      const request = GET(token)
      try {
        const res = await fetch(
          process.env.REACT_APP_BACKEND_URL +
            `/thermal?tgid=${tgid}&start=${start.toISOString()}&end=${end.toISOString()}`,
          request
        )
        const response = await res.json()
        const data = {}
        response.thermal.forEach(obj => {
          data[obj.operation] = obj
        })
        setThermals(Object.keys(data).length > 0 ? data : null)
      } catch (err) {
        console.error('Failed to fetch thermal data:', err)
        setThermals(null)
      } finally {
        setLoading(false)
      }
    }

    if (temperature && targetsview && interval) {
      const start = new Date(temperature.timestamp)
      const end = calculateEndDate(start, interval.value)
      loadData(targetsview.tg_id, start, end)
    } else {
      setThermals(null)
    }
  }, [targetsview, temperature, interval, token])

  if (loading) {
    return (
      <div style={{minHeight: '500px'}}>
        <Spin />
      </div>
    )
  } else {
    return (
      <>
        <Row gutter={CARDS_GUTTER} style={{margin: '0em'}} align="middle">
          <Col xs={24} md={6}>
            <ThermalImage
              label="Maximum"
              temperatures={thermals?.max?.temperatures}
              minimum={temperature?.min}
              maximum={temperature?.max}
            />
          </Col>
          <Col xs={24} md={6}>
            <ThermalImage
              label="Median"
              temperatures={thermals?.median?.temperatures}
              minimum={temperature?.min}
              maximum={temperature?.max}
            />
          </Col>
          <Col xs={24} md={6}>
            <ThermalImage
              label="Mean"
              temperatures={thermals?.mean?.temperatures}
              minimum={temperature?.min}
              maximum={temperature?.max}
            />
          </Col>
          <Col xs={24} md={6}>
            <ThermalImage
              label="Minimum"
              temperatures={thermals?.min?.temperatures}
              minimum={temperature?.min}
              maximum={temperature?.max}
            />
          </Col>
        </Row>
        <Row style={{marginTop: '12px', justifyContent: 'center'}}>
          <Col xs={24} style={{display: 'flex', justifyContent: 'center'}}>
            <ThermalLegend minimum={temperature?.min} maximum={temperature?.max} />
          </Col>
        </Row>
      </>
    )
  }
}

export default ThermalRow
